<template>
  <div>
    <BannerImg
      bannerPosition="GYWM_BANNER"
      title="Eiiplat环境产业互联网平台"
      subTitle="Eiiplat环境产业互联网平台（简称E平台)是面向环境产业数字化、网络化、智能化需求，构建基于海量数据采集、汇聚、分析的服务体系，支撑环境资源泛在连接、弹性供给、高效配置的产业云平台。"
    />

    <div v-if="!active" class="about-container">
      <!--      <div class="about-head">
        <el-row>
          <el-col :xs="8" :md="3" :lg="2">
            <span class="about-head-title" :class="{ active: active == 0 }" @click="active = 0">平台介绍</span>
          </el-col>
          <el-col :xs="8" :md="3" :lg="2">
            <span class="about-head-title" :class="{ active: active == 1 }" @click="active = 1">公司介绍</span>
          </el-col>
        </el-row>
      </div>-->
      <div
        class="about-contant"
        v-for="v in detail"
        :key="v.id"
      >
        <div
          v-for="item in v.contentList"
          :key="item.id"
          v-if="v.moduleName === '自定义模块'"
        >
          <div class="about-contant-title" v-if="item.type === 'title'">
            <h3>{{ item.title }}</h3>
          </div>

          <div
            style="text-align: center"
            class="about-contant-subtitle"
            v-if="item.type === 'subTitle'"
          >
            <span v-if="item.subTitle==='查看更多>'" style="cursor: pointer;color:#D7000F">{{ item.subTitle }}</span>
            <span v-else>{{ item.subTitle }}</span>
          </div>

          <div
            style="text-indent: 2em; padding-bottom: 5px; font-size: 17px;width: 1280px;margin: 0 auto"
            class="text"
            v-if="item.type === 'introduction'"
            v-html="item.introduction"
          ></div>

          <div
            style="margin-top: 50px; width: 1280px; margin: 0 auto"
            class="img"
            v-if="item.type === 'picture' && item.picture =='/api/jz/file/download/ptjz/ac23dd29-2d30-4ba0-bd0f-7fb23095709d.png'"
          >
            <img :src="item.picture" style="width: 100%" />
          </div>
          <div
            style="margin-top: 50px; width: 100%"
            class="img"
            v-if="item.type === 'picture' && item.picture !='/api/jz/file/download/ptjz/ac23dd29-2d30-4ba0-bd0f-7fb23095709d.png' "
          >
            <img :src="item.picture" style="width: 100%" />
          </div>


          <div v-if="item.type === 'video'" style="height: 590px">
            <div
              class="video"
              style="
                width: 1280px;
                height: auto;
                margin: 0 auto 50px auto;
                position: relative;
              "
            >
              <div class="video-box">
                <!-- <video
                  style="width: 100%; height: 100%"
                  :src="item.video"
                  muted
                  loop
                  controls
                >
                  <source type="video/mp4" :src="item.video" />
                </video> -->
                <video id="videoElement" controls class="video" muted></video>
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-if="v.moduleName === '事件模块'">
          <div class="about-contant-title">
            <h3>{{ v.moduleTitle }}</h3>
          </div>
          <el-row :gutter="50">
            <el-col v-for="item in v.contentList" :key="item.id" :xs="24" :md="8" style="margin-bottom: 15px">
              <el-card :body-style="{ padding: '0px', cursor: 'default' }" shadow="hover">
                <img :src="item.picture" style="width: 100%;height: 250px" />
                <div style="padding: 20px;">
                  <div class="card-text-title">{{ item.title.slice(0, 10) }}</div>
                  <div class="card-text-desc">{{ item.introduction }}</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div> -->

      </div>
    </div>

    <!--    <div v-else class="about-container">
      <div class="about-head">
        <el-row>
          <el-col :xs="8" :md="3" :lg="2">
            <span class="about-head-title" :class="{ active: active == 0 }" @click="active = 0">平台介绍</span>
          </el-col>
          <el-col :xs="8" :md="3" :lg="2">
            <span class="about-head-title" :class="{ active: active == 1 }" @click="active = 1">公司介绍</span>
          </el-col>
        </el-row>
      </div>
      <div class="about-contant" v-for="v in detail" :key="v.id">
        <div v-for="item in v.contentList" :key="item.id" v-if="v.moduleName === '自定义模块'">
          <div class="about-contant-title" v-if='item.type === "title"'>
            <span></span>
            <span>{{ item.title }}</span>
          </div>
          <div class="text" v-if='item.type === "introduction"'>{{ item.introduction }}</div>
          <div style="margin-top: 50px;width: 100%;" class="img" v-if='item.type === "picture"'>
            <img :src="item.picture" style="width: 100%" />
          </div>
        </div>
        <div v-if="v.moduleName === '成果模块'">
          <div class="about-contant-title">
            <span></span>
            <span>{{ v.moduleTitle }}</span>
          </div>
          <el-row :gutter="50">
            <el-col v-for="item in v.contentList" :key="item.id" :xs="24" :md="8" style="margin-bottom: 15px">
              <el-card :body-style="{ padding: '0px', cursor: 'default' }" shadow="hover">
                <img :src="item.picture" style="width: 100%;height: 250px" />
                <div style="padding: 20px;">
                  <div class="card-text-desc">{{ item.introduction }}</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>

    </div>-->
    <div v-if="showButton" class="to-top" @click="totop()">
      <img src="../assets/images/totop.png" alt="" />
    </div>
  </div>
</template>

<script>
import { platformDetail, componyDetail, listBanner } from "@/api";
import BannerImg from "@/components/BannerImg.vue";
import flvjs from 'flv.js'
export default {
  name: "AboutUs",
  metaInfo: {
    title: 'Eiiplat环境产业互联网平台关于我们',
    meta: [
      { name: 'description', content: '青岛国真智慧Eiiplat环境产业物联网平台是国内首家环境产业工业互联网平台。Eiiplat平台致力于服务环境产业固废、污水、大气、噪音、辐射五大行业，其中以固废切入点，打造了智能设计、智能供应、施工管理、智能收运、智能管控 、机制管理、财务管理、OKR管理八大应用，赋能行业转型升级。利用资金流驱动废弃物的循环流动，优化过程数据提高效率，对废弃物全生命周期追溯，为客户提高生产效率和降低运营成本提供持续的解决方案。 机制管理、财务管理、OKR管理八大应用，赋能行业转型升级。利用资金流驱动废弃物的循环流动，优化过程数据提高效率，对废弃物全生命周期追溯，为客户提高生产效率和降低运营成本提供持续的解决方案。' },
      { name: 'keywords', content: '青岛国真智慧Eiiplat环境产业物联网平台是国内首家环境产业工业互联网平台。Eiiplat平台致力于服务环境产业固废、污水、大气、噪音、辐射五大行业，其中以固废切入点，打造了智能设计、智能供应、施工管理、智能收运、智能管控 、机制管理、财务管理、OKR管理八大应用，赋能行业转型升级。' },
    ],
  },
  components: { BannerImg },
  data() {
    return {
      active: 0,
       // 返回顶部按钮
      showButton: false,
      detail: [],
    };
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    // 获取数据
    this.getData();
  },
  watch: {
    active(newVal) {
      this.getData();
    },
  },
  methods: {
    totop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 使滚动效果平滑
      });
    },
     handleScroll() {
      this.showButton = window.scrollY > 200;
    },
    async getData() {
      this.detail = [];
      if (this.active === 0) {
        //平台介绍
        const res = await platformDetail();
        this.detail = res.rows;
        res.rows.some(item=>{
            return item.contentList.some(item2=>{
              if (item2.type == 'video') {
                this.$nextTick(()=>{
                  this.play(item2.video)
                })
              }

              return item2.type == 'video'
            })
        })
      } else {
        //公司介绍
        const res = await componyDetail();
        this.detail = res.rows;
      }
    },
    /**
     * 放视频啦
     */
    play(videoUrl) {
      // 视频是单独的端口
      if(flvjs.isSupported()){const videoElement = document.getElementById("videoElement"); //获取video的dom元素
          const flvPlayer = flvjs.createPlayer({
            type: 'flv',
            isLive: true,
            hasAudio: false,
            url: videoUrl
          },{
            autoCleanupSourceBuffer:true, // 对SourceBuffer进行自动清理缓存
            enableStashBuffer: false, // 关闭IO隐藏缓冲区
            stashInitialSize: 128
          });
          flvPlayer.attachMediaElement(videoElement);
          flvPlayer.load();
          flvPlayer.play();
          // this.playList.push(flvPlayer);
          // 事件监听
          flvPlayer.on(flvjs.Events.ERROR,(err, errdet) =>{
            if(err == flvjs.ErrorTypes.NETWORK_ERROR){
              this.singleDestroy(flvPlayer);
              this.$publicmethod.showMessage("连接超时", this.$publicmethod.ErrorType)
            }
            if(err == flvjs.ErrorTypes.OTHER_ERROR){
              this.singleDestroy(flvPlayer);
              this.$publicmethod.showMessage("其他异常", this.$publicmethod.ErrorType)
            }
          })
      }else{
        this.$publicmethod.showMessage("flvjs不支持", this.$publicmethod.ErrorType)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.to-top {
  cursor: pointer;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  // border: 1px solid #ccc;
  position: fixed;
  z-index: 9999999;
  bottom: 100px;
  right: 100px;
  background-color: #fff;
  box-shadow: 0px 0px 8px 2px #ccc;
  img {
    width: 50%;
    height: 50%;
  }
}
.video-box {
  width: 100%;
  padding: 20px;
  position: absolute;
  top: -155px;
  background: #fff9;
  box-shadow: 0px 0px 11px #eee;
}
.about-container {
  // display: flex;
  // justify-content: center;
  // flex-wrap: wrap;
  min-height: 340px;
  // padding-bottom: 80px;

  .img {
    width: 100%;
    margin-top: 25px;
    // margin-bottom: 25px;
  }
  .video {
    width: 100%;
  }

  .about-head {
    width: 75%;
    margin-top: 50px;

    .about-head-title {
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      cursor: pointer;
    }

    .active {
      color: #e50009;
    }
  }

  .about-contant {
    // width: 75%;
    /* margin-bottom: 50px; */

    .culture-card {
      box-shadow: 0rem 0.04rem 0.3rem 0rem rgba(204, 204, 204, 0.7);
      margin-bottom: 40px;
    }

    .text {
      font-size: 16px;
      font-weight: 500;
      color: rgba(19, 20, 21, 0.7);
      line-height: 32px;
    }

    .about-contant-title {
      height: 45px;
      margin: 50px 0 0 0;
      font-weight: 500;
      color: #000000;

      //:first-child {
      //  display: inline-block;
      //  width: 3px;
      //  height: 20px;
      //  background: #E50009;
      //  margin-right: 5px;
      //}

      //span {
      //  font-size: 32px;
      //}
      h3 {
        color: var(---333, #333);
        text-align: center;
        /* 一级标题-30 */
        font-size: 30px;
        font-style: normal;
        font-weight: 600;
        line-height: 30px; /* 100% */
        margin-block: 60px;
      }
    }

    .card-text-title {
      font-size: 16px;
      font-weight: 600;
      color: #131415;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .card-text-desc {
      height: 65px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(19, 20, 21, 0.7);
      margin-top: 15px;
      word-break: break-all;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    .card-text-icon {
      margin-left: 10px;
      margin-bottom: 10px;
      color: #e50009;
      cursor: default;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue